import React from "react";
import { Route, Routes } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import DashboardPage from "../pages/DashboardPage";
import ResetPassword from "../components/login/ResetPassword";
// import Otp from "../components/login/Otp";
// import NewDetails from "../components/login/NewDetails";
import CooperativesListPage from "../pages/CooperativesListPage";
import CooperativesDetailsPage from "../pages/CooperativesDetailsPage";
import ComplaintsPage from "../pages/ComplaintsPage";
import ComplaintsListPage from "../pages/ComplaintsListPage";
import ComplaintsDetailsPage from "../pages/ComplaintsDetailsPage";
import NoticesPage from "../pages/NoticesPage";
import RegisterNewPage from "../pages/RegisterNewPage";
// import ApplicationsPage from "../pages/ApplicationsPage";
import UserPage from "../pages/UserPage";
import AddUserPage from "../pages/AddUserPage";
import EditUserPage from "../pages/EditUserPage";
import ViewUserPage from "../pages/ViewUserPage";
import SettingsPage from "../pages/SettingsPage";
import AdminPage from "../pages/AdminPage";
import CreateComplaintPage from "../pages/CreateComplaintPage";
import ViewComplaintsPage from "../pages/ViewComplaintsPage";
import CreateNoticesPage from "../pages/CreateNoticesPage";
import EditNoticesPage from "../pages/EditNoticesPage";
import EditRegisterPage from "../pages/EditRegisterPage";
import { useRole } from "../hooks/useRole";
import { usePermission } from "../hooks/usePermission";

const Main = () => {
  const { isSuperAdmin } = useRole();
  const { canView, canCreate, canEdit } = usePermission();
  return (
    <>
      <Routes>
        {canView("dashboard") && <Route path="/" element={<DashboardPage />} />}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* <Route path="/otp" element={<Otp />} />
        <Route path="/new-account-details" element={<NewDetails />} /> */}
        {canView("cooperatives") && (
          <>
            <Route
              path="/cooperatives-list"
              element={<CooperativesListPage />}
            />
            <Route
              path="/cooperatives-list/:id"
              element={<CooperativesDetailsPage />}
            />
            {canEdit("cooperatives") && (
              <Route path="/register/edit/:id" element={<EditRegisterPage />} />
            )}
          </>
        )}

        {canView("complaints") && (
          <>
            <Route path="/complaints" element={<ComplaintsPage />} />
            <Route path="/complaints-list" element={<ComplaintsListPage />} />
            <Route
              path="/complaints/view/:id"
              element={<ViewComplaintsPage />}
            />
            {canEdit("complaints") && (
              <Route
                path="/complaints/edit/:id"
                element={<ComplaintsDetailsPage />}
              />
            )}
            {canCreate("complaints") && (
              <Route
                path="/complaints/create"
                element={<CreateComplaintPage />}
              />
            )}
          </>
        )}
        {canView("notices") && (
          <>
            <Route path="/notices" element={<NoticesPage />} />
            {canCreate("notices") && (
              <Route path="/notices/create" element={<CreateNoticesPage />} />
            )}
            {canEdit("notices") && (
              <Route path="/notices/edit/:id" element={<EditNoticesPage />} />
            )}
          </>
        )}
        <Route path="/register-new" element={<RegisterNewPage />} />
        {/* <Route path="/applications" element={<ApplicationsPage />} /> */}
        {(isSuperAdmin || canView("Users")) && (
          <>
            <Route path="/user" element={<UserPage />} />
            {(isSuperAdmin || canCreate("Users")) && (
              <Route path="/user/add" element={<AddUserPage />} />
            )}
            {(isSuperAdmin || canEdit("Users")) && (
              <Route path="/user/edit/:id" element={<EditUserPage />} />
            )}
            <Route path="/user/view/:id" element={<ViewUserPage />} />
          </>
        )}
        {(isSuperAdmin || canView("Settings")) && (
          <Route path="/settings" element={<SettingsPage />} />
        )}
        {(isSuperAdmin || canView("Admin Control")) && (
          <Route path="/admin" element={<AdminPage />} />
        )}
      </Routes>
    </>
  );
};

export default Main;
